import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IProductColorRequest } from '../models/models'

export class AddProductColorApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/color/insertColor',
      requesterInfo,
    })
  }

  public async addProductColor(request: IProductColorRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
